export function getProspectLabelByStep(id_step: number | null) {
  if (!id_step) return null;

  if (id_step >= 0 && id_step < 3) {
    return "En cours d'inscription";
  } else if (id_step === 3) {
    return 'Déjà inscris';
  } else {
    return null;
  }
}
